import { PageHero } from "@/components/sections/PageHero";
import { CTABand } from "@/components/sections/CTABand";
import { CAPABILITIES, IMAGES } from "@/lib/site";

const detail = [
  { h: "Two Powder Coating Ovens", p: "Sized for long structural members and high-throughput batch cycles. Cure schedules are controlled to the powder manufacturer's spec." },
  { h: "Two Spray Booths", p: "Independent electrostatic spray lines allow us to run two colors or two customers simultaneously without cross-contamination." },
  { h: "Walk-In Blast Room", p: "Steel shot, aluminum oxide, garnet, and specialty media stocked. SSPC-SP profile targets supported for demanding coatings." },
  { h: "Chemical Strip Tank", p: "Dedicated immersion tank removes powder, e-coat, and enamels without heat damage — safe for aluminum and thin steel." },
  { h: "Forklifts & Overhead Handling", p: "Heavy weldments, long extrusions, and awkward assemblies move through the facility safely and repeatably." },
  { h: "3D-Printed Masking Fixtures", p: "Custom masking plugs, caps, and jigs produced in-house. Perfect edges, zero post-cure cleanup, run after run." },
];

export default function Capabilities() {
  return (
    <div data-testid="capabilities-page">
      <PageHero
        eyebrow="Capabilities"
        title={<>Spec sheet. <span className="text-[#FF5722]">Not a brochure.</span></>}
        subtitle="What is on the floor, what it can handle, and what your parts will actually run through."
        image={IMAGES.forklift}
      />

      <section className="section px-6 lg:px-10">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 border-t border-l border-white/10 mb-20">
          {CAPABILITIES.map(c => (
            <div key={c.label} className="border-r border-b border-white/10 p-6" data-testid={`cap-${c.label.replace(/\s/g, '-')}`}>
              <div className="text-xs uppercase tracking-widest text-zinc-500">{c.label}</div>
              <div className="font-display text-2xl md:text-3xl mt-2 tracking-tight">{c.value}</div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {detail.map(d => (
            <div key={d.h} className="border border-white/10 p-8 hover:border-[#FF5722] transition-colors">
              <h3 className="font-display text-2xl md:text-3xl tracking-tight">{d.h}</h3>
              <p className="mt-4 text-zinc-300 leading-relaxed">{d.p}</p>
            </div>
          ))}
        </div>
      </section>

      <CTABand />
    </div>
  );
}
